import React from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
//#endregion
//#region components
import { OwnersWidgetContainer } from "components/shareRegister";
//#endregion

const OwnersWidgetForRevisor: React.FC = () => {
  const financialYear = useSelector((store: AppState) => store.auth.selectedCompany.annualAccountsFinancialYear);

  return <OwnersWidgetContainer snapshotDate={financialYear?.end} />;
};

export default OwnersWidgetForRevisor;
